export function formatTwoDigits(value) {
  return value < 10 ? '0' + value : value;
}

export function formatDateToDateTime(selectedDay, timeSlot) {
  const year = selectedDay.getFullYear();
  const month = selectedDay.getMonth() + 1;
  const date = selectedDay.getDate();
  return `${year}-${formatTwoDigits(month)}-${formatTwoDigits(date)} ${timeSlot}`;
}

export function formatDateDescription(selectedDay, timeSlot) {
  const dayNames = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
  const dayName = dayNames[selectedDay.getDay()].toUpperCase();
  const dateStr = `${formatTwoDigits(selectedDay.getDate())}.${formatTwoDigits(
    selectedDay.getMonth() + 1
  )}.${selectedDay.getFullYear()}`;
  return `${dayName}, ${dateStr} ${timeSlot.substr(0, 5)}`;
}
